import Vue from 'vue/dist/vue.esm'
import template from './district_all_sessions_report_template.slim'
import chartFilterable from '../../mixins/chart_filterable';
import chartResponsiveWidth from '../../mixins/chart_responsive_width'
import singleSeriesLineChart from '../../mixins/single_series_line_chart'

Vue.component('district_all_sessions_report', {
  mixins: [template, chartFilterable, chartResponsiveWidth, singleSeriesLineChart],
  props: ['school_year_label', 'year_info', 'report_date', 'section', 'templates'],
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: true,
            autoScaleYaxis: true
          },
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: "District sessions",
            style: {
              color: '#949494'
            }
          },
          forceNiceScale: true
        },
        grid: {
          row: {
            colors: ['#FFFFFF', '#F3F3F3']
          }
        }
      }
    }
  }
});
